export default __webpack_public_path__ + "static/media/SENAIT_FR_SEQ03.f82c8d2d.mp3";